// extracted by mini-css-extract-plugin
module.exports = {"text":"styles__text___1xpll","container":"styles__container___2Yx2s","link":"styles__link___M8Hda","icon":"styles__icon___2-Bpm"};